import {Provider} from '@angular/core';

import {MyHistoryCreditUseCase} from '@features/credit/application/use_cases/my-history-credit/my-history-credit.use-case';

import {
  MyHistoryCreditHttpProvider
} from '@features/credit/infrastructure/http/my-history-credit/my-history-credit.http.provider';

export const MyHistoryCreditUseCaseProvider: Provider[] = [
  ...MyHistoryCreditHttpProvider,
  MyHistoryCreditUseCase
];
